<template>
<div class="flex-column align-center">
    <span class="mouse" />
</div>
</template>
<script>
export default {
  name: "Mouse"
};
</script>
<style scoped>
.mouse {
  position: relative;
  bottom: 40px;
  margin: 0 auto;
  height: 35px;
  width: 20px;
  border-radius: 10px;
  transform: translateY(150px);
  border: 2px solid white;
}
.mouse:after {
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: white;
  position: absolute;
  top: 5px;
  left: 0;
  right: 0;
  margin: 0 auto;
  animation: mouse-move 1.4s ease-in-out infinite;
}

@keyframes mouse-move {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(12px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
